import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/OtherInputs.api';


export const getOtherInputsRequest = () => ({
  type: actionTypes.GET_OTHER_INPUTS_REQUEST,
});

export const getOtherInputsSuccess = (maternity) => ({
  type: actionTypes.GET_OTHER_INPUTS_SUCCESS,
  payload: maternity,
});

export const getOtherInputsFailure = (error) => ({
  type: actionTypes.GET_OTHER_INPUTS_FAILURE,
  payload: error,
});

export const getOtherInputs = (date) => {
  return async (dispatch) => {
    dispatch(getOtherInputsRequest(date));
    try {
      const leaves = await api.fetchOtherInputsData(date);
      dispatch(getOtherInputsSuccess(leaves));
      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getOtherInputsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const updateOtherInputsRequest = (id, OtherInputsData) => ({
  type: actionTypes.UPDATE_OTHER_INPUTS_REQUEST,
  payload: { id, OtherInputsData },
});

export const updateOtherInputsSuccess = (message) => ({
  type: actionTypes.UPDATE_OTHER_INPUTS_SUCCESS,
  payload: message,
});

export const updateOtherInputsFailure = (error) => ({
  type: actionTypes.UPDATE_OTHER_INPUTS_FAILURE,
  payload: error,
});

export const updateOtherInputsById = (id, OtherInputsData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    OtherInputsData.updated_by = user.user_name;

    dispatch(updateOtherInputsRequest(id, OtherInputsData));
    try {
      const response = await api.updateOtherInputs(id, OtherInputsData);
      dispatch(updateOtherInputsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateOtherInputsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const deleteOtherInputsRequest = (id) => ({
  type: actionTypes.DELETE_OTHER_INPUTS_REQUEST,
  payload: id,
});

export const deleteOtherInputsSuccess = (message) => ({
  type: actionTypes.DELETE_OTHER_INPUTS_SUCCESS,
  payload: message,
});

export const deleteaternityBenefitsFailure = (error) => ({
  type: actionTypes.DELETE_OTHER_INPUTS_FAILURE,
  payload: error,
});

export const deleteOtherInputsById = (id) => {
  return async (dispatch) => {
    dispatch(deleteOtherInputsRequest(id));
    try {
      const response = await api.deleteOtherInputs(id);
      dispatch(deleteOtherInputsSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteaternityBenefitsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const uploadOtherInputsRequest = (fileData) => ({
  type: actionTypes.UPLOAD_OTHER_INPUTS_REQUEST,
  payload: fileData,
});

export const uploadOtherInputsSuccess = (message) => ({
  type: actionTypes.UPLOAD_OTHER_INPUTS_SUCCESS,
  payload: message,
});

export const uploadOtherInputsFailure = (error) => ({
  type: actionTypes.UPLOAD_OTHER_INPUTS_FAILURE,
  payload: error,
});

export const uploadOtherInputsFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadOtherInputsRequest(fileData));
    try {
      const response = await api.otherInputsUpload(fileData);
      dispatch(uploadOtherInputsSuccess(response));
      return { success: true, data: response };

    } catch (error) {
      dispatch(uploadOtherInputsFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};


export const multiDaleteOtherInputsRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_OTHER_INPUTS_REQUEST,
  payload: ids,
});

export const multiDaleteOtherInputsSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_OTHER_INPUTS_SUCCESS,
  payload: message,
});

export const multiDaleteOtherInputsFailure = (error) => ({
  type: actionTypes.MULTIDELETE_OTHER_INPUTS_FAILURE,
  payload: error,
});

export const multiDeleteOtherInputss = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteOtherInputsRequest(ids));
    try {
      const response = await api.multiDeleteOtherInputs(ids);
      dispatch(multiDaleteOtherInputsSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteOtherInputsFailure(error));
      return { success: false, message: error };
    }
  };
};


